const { TextControl, ToggleControl, TextareaControl } = wp.components;
const { registerPlugin } = wp.plugins;
const { PluginDocumentSettingPanel } = wp.editor;
const { useSelect, useDispatch } = wp.data;
const { __ } = wp.i18n;


/**
 * Represents a custom meta panel component.
 * @function ExternalLinkPanel
 * @return {JSX.Element} A custom meta panel.
 */
export const ExternalLinkPanel = () => {

	const externalLink = useSelect( ( select ) => (
		select( 'core/editor' ).getEditedPostAttribute( 'meta' ).integration_external_link
	), [] );

	const externalLinkTab = useSelect( ( select ) => (
		select( 'core/editor' ).getEditedPostAttribute( 'meta' ).integration_external_link_tab
	), [] );

	const externalLinkText = useSelect( ( select ) => (
		select( 'core/editor' ).getEditedPostAttribute( 'meta' ).integration_external_link_text
	), [] );

	const externalLinkRel = useSelect( ( select ) => (
		select( 'core/editor' ).getEditedPostAttribute( 'meta' ).integration_external_link_rel
	), [] );

	const { editPost } = useDispatch( 'core/editor' );

	return (
		<>
			<TextControl
				__next40pxDefaultSize
				label={__( 'External link', 'wombat' )}
				help={__( 'Paste integration URL here.', 'wombat' )}
				onChange={( value ) => {

					editPost( { meta: { integration_external_link: value } } );

				}}
				value={externalLink}
				type={'url'}
			/>
			<TextControl
				__next40pxDefaultSize
				label={__( 'Button text', 'wombat' )}
				help={__( 'Text visible on link button', 'wombat' )}
				onChange={( value ) => {

					editPost( { meta: { integration_external_link_text: value } } );

				}}
				value={externalLinkText}
			/>
			<ToggleControl
				label={__( 'Open in new tab', 'wombat' )}
				checked={externalLinkTab === '_blank'}
				onChange={( value ) => {

					let target = '_blank';
					if ( !value ) {

						target = '_self';

					}
					editPost( { meta: { integration_external_link_tab: target } } );

				}}
			/>
			<TextControl
				__next40pxDefaultSize
				label={__( 'Link REL', 'wombat' )}
				help={__( 'eg. noopener nofollow', 'wombat' )}
				onChange={( value ) => {

					editPost( { meta: { integration_external_link_rel: value } } );

				}}
				value={externalLinkRel}
			/>
		</>
	);

};

/**
 * TitlePanel component for managing the title of a post in the editor.
 * @function TitlePanel
 * @return {JSX.Element} A custom meta panel.
 */
export const TitlePanel = () => {

	const title = useSelect( ( select ) => (
		select( 'core/editor' ).getEditedPostAttribute( 'meta' ).integration_title
	), [] );

	const { editPost } = useDispatch( 'core/editor' );

	return (
		<>
			<TextareaControl
				__next40pxDefaultSize
				label={__( 'Title', 'wombat' )}
				onChange={( value ) => {

					editPost( { meta: { integration_title: value } } );

				}}
				value={title}
			/>
		</>
	);

};

registerPlugin( 'integrations-custom-title-panel', {
	render: () => {

		const postType = useSelect( select => select( 'core/editor' ).getCurrentPostType(), [] );

		if ( postType !== 'smoobu_integrations' ) {

			return null;

		}

		return (

			<PluginDocumentSettingPanel
				name="integrations-custom-title-panel"
				title="Additional title"
				className="integrations-custom-title-panel"
			>
				<TitlePanel/>
			</PluginDocumentSettingPanel>

		);

	},
} );


registerPlugin( 'integrations-custom-panel', {
	render: () => {

		const postType = useSelect( select => select( 'core/editor' ).getCurrentPostType(), [] );

		if ( postType !== 'smoobu_integrations' ) {

			return null;

		}

		return (
			<PluginDocumentSettingPanel
				name="integrations-custom-panel"
				title="External link"
				className="integrations-custom-panel"
			>
				<ExternalLinkPanel/>
			</PluginDocumentSettingPanel>
		);

	},
} );


